<template>
  <div v-if="!isAddPatient" class="hospital-container container">
    <span class="basic-title">入院急救：</span>
    <div class="detail-info hospital-info">
      <span class="info-key">操作：</span>
      <!-- 展示页面 -->
      <span v-if="isShowPatient" class="info-item">
        {{ operate }}
      </span>
      <!-- 补写页面 -->
      <el-input
        v-else-if="isWriteMore"
        v-model="operate"
        class="operationInput"
        placeholder=""
        type="textarea"
        resize="none"
        :rows="6"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "HospitalEmergency",
  data() {
    return {
      operate: "",
    };
  },
  computed: {
    ...mapState({
      patient: "showOrEditPatientInfo"
    }),
    isAddPatient() {
      return this.patient?.pageInfo?.isAddPatient;
    },
    isShowPatient() {
      return this.patient?.pageInfo?.isShowPatient;
    },

    isWriteMore() {
      return this.patient?.pageInfo?.isWriteMore;
    }
  },

  watch: {
    patient: {
      handler(val) {
        const { inhospitalmedicals } = val;
        if (inhospitalmedicals.length) {
          this.operate = inhospitalmedicals[0]?.operate;
        }
      },
      immediate: true
    }
  },
};
</script>

<style lang="scss" scoped>
.hospital-info {
  padding-top: 12px;
  position: relative;
}

.operationInput {
  width: 800px;
  padding-left: 110px;
}

</style>
